
const LoginPageReducer = (state = {pageName:"login"}, action) => {
	if(action.type === 'SET_LOGIN_PAGE') {
		var newState = {};
		Object.assign(newState,state);
		newState[action.key] = action.payload;
		return newState;
	}else {
		return state
	}
}

export default LoginPageReducer